import { render, staticRenderFns } from "./JDictionary.vue?vue&type=template&id=99772f46"
import script from "./JDictionary.vue?vue&type=script&lang=js"
export * from "./JDictionary.vue?vue&type=script&lang=js"
import style0 from "./JDictionary.vue?vue&type=style&index=0&id=99772f46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports